import _ from 'lodash'

const isLoading = (state) => _.get(state, 'loading')
const isCategoriesLoading = (state) => _.get(state, 'loadingCategories')
const event = (state) => _.get(state, 'event')
const events = (state) => _.get(state, 'events')
const eventErrors = (state) => _.get(state, 'errors')
const agendaEvent = (state) => _.get(state, 'agenda')
const partners = (state) => _.get(state, 'partners')
const attendees = (state) => _.get(state, 'attendees')
const attendee = (state) => _.get(state, 'attendee')
const session = (state) => _.get(state, 'session')
const sessionQuestions = (state) => _.get(state, 'sessionQuestions')

const categories = (state) => _.get(state, 'categories')
const actionFiles = (state) => _.get(state, 'actionFiles')
const actionLinks = (state) => _.get(state, 'actionLinks')

const actionLinksMeta = (state) => _.get(state, 'actionLinksMeta')
const actionFilesMeta = (state) => _.get(state, 'actionFilesMeta')
const sessionQuestionsMeta = (state) => _.get(state, 'sessionQuestionsMeta')

const pageCountEvents = (state) => _.get(state, 'pageCount.events')
const pageCountAgendas = (state) => _.get(state, 'pageCount.agendas')
const pageCountPartners = (state) => _.get(state, 'pageCount.partners')
const pageCountAttendees = (state) => _.get(state, 'pageCount.attendees')

const totalCountAttendees = (state) => _.get(state, 'totalCount.attendees')
const categoriesMeta = (state) => _.get(state, 'categoriesMeta')

const eventTracks = (state) => _.get(state, 'tracks')
const eventTracksMeta = (state) => _.get(state, 'tracksMeta')
const isTracksLoading = (state) => _.get(state, 'loadingTracks')
const isMyAgendaLoading = (state) => _.get(state, 'myAgendaIsLoading')
const myAgendaIdIsLoading = (state) => _.get(state, 'myAgendaIdIsLoading')
const pollsLoading = (state) => _.get(state, 'pollsLoading')
const ratingsLoading = (state) => _.get(state, 'ratingsLoading')
const eventSpeakers = (state) => _.get(state, 'speakers')
const eventSpeakersMeta = (state) => _.get(state, 'speakersMeta')
const exhibitor = (state) => _.get(state, 'exhibitor')
const exhibitorFollow = (state) => _.get(state, 'exhibitorPartner.follow_status', null)
const exhibitorNote = (state) => _.get(state, 'exhibitorPartner.follow_note', '')
const boothStaffList = (state) => _.get(state, 'boothStaffList')
const boothStaffLoading = (state) => _.get(state, 'boothStaffLoading')
const pageCountBoothStaff = (state) => _.get(state, 'pageCount.boothStaff')
const totalCountBoothStaff = (state) => _.get(state, 'totalCount.boothStaff')

const sessionRegisterLoading = (state) => _.get(state, 'sessionRegisterLoading')
const sessionRegister = (state) => _.get(state, 'sessionRegister')
const exhibitorError = (state) => _.get(state, 'exhibitorError')

const privateLoading = (state) => _.get(state, 'privateLoading')
const subSessions = (state) => _.get(state, 'subSessions')
const subSessionsLoading = (state) => _.get(state, 'subSessionsLoading')
const subSessionsError = (state) => _.get(state, 'subSessionsError')
const subSessionsPageCount = (state) => _.get(state, 'pageCount.subSessions')
const sessionSpeakers = (state) => _.get(state, 'sessionAllSpeakers')
const isLoadingSpeakers = (state) => _.get(state, 'sessionAllSpeakersLoading')
const sessionSpeakersError = (state) => _.get(state, 'sessionAllSpeakersError')
const sessionSpeakersPageCount = (state) => _.get(state, 'pageCount.sessionsSpeakers')
const deleteQuestionLoading = (state) => _.get(state, 'deleteQuestionLoading')
const survey = (state) => _.get(state, 'survey')
const isLoadingSurvey = (state) => _.get(state, 'loading')
const surveyError = (state) => _.get(state, 'surveyError')
const postSurveyLoading = (state) => _.get(state, 'surveyLoading')
const partnerFiles = (state) => _.get(state, 'partnerFiles')
const partnerFilesLoading = (state) => _.get(state, 'partnerFilesLoading')
const partnerFilesError = (state) => _.get(state, 'partnerFilesError')
const partnerFilesPageCount = (state) => _.get(state, 'pageCount.partnerFiles')
const giveaways = (state) => _.get(state, 'giveaways')
const giveawaysLoading = (state) => _.get(state, 'giveawaysLoading')
const giveawaysError = (state) => _.get(state, 'giveawaysError')
const giveawaysPageCount = (state) => _.get(state, 'pageCount.giveawaysCount')
const surveyPostError = (state) => _.get(state, 'surveyPostError')
const dateListEvent = (state) => _.get(state, 'dateListEvent')
const dateListLoading = (state) => _.get(state, 'dateListLoading')
const dateListError = (state) => _.get(state, 'dateListError')
const speakerFilter = (state) => _.get(state, 'speakerFilter')
const speakerFilterMeta = (state) => _.get(state, 'speakerFilterMeta')
const isSpeakerFilterLoading = (state) => _.get(state, 'isSpeakerFilterLoading')
const speakerFilterError = (state) => _.get(state, 'speakerFilterError')

export default {
	isLoading,
	event,
	eventErrors,
	agendaEvent,
	events,
	pageCountEvents,
	pageCountAgendas,
	pageCountPartners,
	partners,
	attendees,
	session,
	sessionQuestions,
	pageCountAttendees,
	categories,
	attendee,
	actionFiles,
	actionLinks,

	actionFilesMeta,
	actionLinksMeta,
	sessionQuestionsMeta,

	totalCountAttendees,
	categoriesMeta,
	isCategoriesLoading,

	eventTracks,
	eventTracksMeta,
	isTracksLoading,
	isMyAgendaLoading,
	myAgendaIdIsLoading,
	pollsLoading,
	ratingsLoading,
	eventSpeakers,
	eventSpeakersMeta,
	exhibitor,
	exhibitorFollow,
	exhibitorNote,
	boothStaffList,
	boothStaffLoading,
	pageCountBoothStaff,
	totalCountBoothStaff,
	sessionRegisterLoading,
	sessionRegister,
	exhibitorError,
	privateLoading,
	subSessions,
	subSessionsLoading,
	subSessionsError,
	subSessionsPageCount,
	sessionSpeakers,
	isLoadingSpeakers,
	sessionSpeakersError,
	sessionSpeakersPageCount,
	deleteQuestionLoading,
	survey,
	isLoadingSurvey,
	surveyError,
	postSurveyLoading,
    partnerFiles,
    partnerFilesLoading,
    partnerFilesError,
    partnerFilesPageCount,
    giveaways,
    giveawaysLoading,
    giveawaysError,
    giveawaysPageCount,
    surveyPostError,
    dateListEvent,
    dateListLoading,
    dateListError,
    speakerFilter,
    speakerFilterMeta,
    isSpeakerFilterLoading,
    speakerFilterError
}
